import { BLOCKS, INLINES } from '@contentful/rich-text-types'
import ContentfulFootnoteSup from '@entries/contentful-footnote-sup'
import { withDisplayName } from '@hocs/with-display-name'
import RichText from '@resolvers/rich-text/rich-text'
import clsx from 'clsx'
import { graphql } from 'gatsby'
import React from 'react'

import { ContentType } from './content-types'

const ContentfulNumberHighlight: Utils.EntryFC<
  Queries.ContentfulNumberHighlightFragment
> = ({
  content: { number, description },
  entryInspectorProps,
  fieldInspectorProps,
  titleSize = 'small',
}) => (
  <div
    {...entryInspectorProps()}
    {...fieldInspectorProps({
      fieldId: 'number',
    })}
    className="flex h-full w-full items-center justify-center rounded-[16px] border border-solid border-background-default bg-background-default p-6 opacity-95 tablet:p-0"
  >
    <div className="text-center">
      <h3
        className={clsx(
          'text-bold pb-2 text-center',
          titleSize === 'big' ? 'text-[48px]' : 'text-[30px]/[36px]'
        )}
      >
        {number}
      </h3>
      <RichText
        content={description}
        options={{
          renderNode: {
            [BLOCKS.PARAGRAPH]: (node, children) => (
              <span className="text-[18px]/[21.6px]">{children}</span>
            ),
            [INLINES.EMBEDDED_ENTRY]: {
              [ContentType.ContentfulFootnote]: ContentfulFootnoteSup,
            },
          },
        }}
      />
    </div>
  </div>
)

export const query = graphql`
  fragment ContentfulNumberHighlight on ContentfulNumberHighlight {
    ...ContentfulEntry
    number
    description {
      rich
      references {
        ...ContentfulFootnoteSup
      }
    }
  }
`

export default withDisplayName(
  ContentfulNumberHighlight,
  'ContentfulNumberHighlight'
)
